import React from "react";
import {
  DashboardEmptyState,
  HubTableTemplate,
} from "../../components";

const items = [
  { id: "shipmentNumber", label: "Shipment #" },
  { id: "customer", label: "Customer" },
  { id: "revenue", label: "Revenue" },
  { id: "weight", label: "Weight" },
  { id: "createdAt", label: "Created" },
  { id: "createdBy", label: "Created By" },
];

const keys = [
  {
    variant: "blueBold",
    value: "shipmentNumber",
    navigate: true,
    route: "shipments",
    id: "id",
  },
  { value: "customer.name", defaultValue: "—" },
  { value: "revenue", isCurrency: true },
  { value: "weight", defaultValue: 0 },
  { value: "createdAt", isDate: true },
  { value: "createdBy", isUser: true, userProps: { size: "18px" } },
];

export const RecentShipmentsTable = ({ rows = [], isLoading }) => {
  if (!isLoading && !rows.length) {
    return (
      <DashboardEmptyState
        icon="Archive"
        title="No recent shipments"
        subtitle="Outbound shipments will show up here once created."
      />
    );
  }
  return (
    <HubTableTemplate
      id="dashboard-recent-shipments"
      headerProps={{ items }}
      bodyProps={{ items: rows, keys }}
      isLoading={isLoading}
    />
  );
};

export default RecentShipmentsTable;
